export default __webpack_public_path__ + "static/media/team32.83348056.JPG";